import { Box, Icon, Tooltip } from "@mui/material";
import MDButton from "components/MDButton";
import ModalCarpetaCursos from "components/ModalCarpetasCursos/new-carpeta-cursos";
import useModalHandler from "hooks/useModalHandler";
import { useDeleteTagsMutation } from "services/escuela/tags/useCases/deleteTags";
import React from "react";
import { CURSOS_LIST_URL } from "config/bases_url";
import { useRedirectForm } from "hooks/useRedirectForm";
import { handleToast } from "helpers/handleToast";
import MDSelect from "components/MDSelect";
import MDBox from "components/MDBox";

export const FiltersComponentCarpeta = ({
  carpeta,
  handleChange,
  carpetas,
}) => {
  //Props del modal de carpetas
  const {
    open: openCarpeta,
    handleOpen: handleOpenCarpeta,
    handleClose: handleCloseCarpeta,
  } = useModalHandler();

  const [editCarpeta, setEditCarpeta] = React.useState(null);
  const [
    deleteTag,
    {
      isLoading: isDeletingTag,
      error: deleteTagError,
      isError: isErrorTag,
      isSuccess: isSuccessTag,
    },
  ] = useDeleteTagsMutation();

  const handleEditCarpeta = async (carpeta, event) => {
    event.stopPropagation();
    setEditCarpeta(carpeta);
    handleOpenCarpeta();
  };

  const handleDeleteCarpeta = async (id, event) => {
    event.stopPropagation();
    try {
      await deleteTag(id).unwrap();
    } catch (err) {
      console.error("Error al eliminar la carpeta:", err);
    }
  };

  useRedirectForm(
    isDeletingTag,
    isSuccessTag,
    isErrorTag,
    deleteTagError,
    "Carpeta eliminada correctamente",
    CURSOS_LIST_URL,
  );

  return (
    <>
      <ModalCarpetaCursos
        open={openCarpeta}
        handleClose={handleCloseCarpeta}
        edit={editCarpeta}
      />
      <MDBox display="flex" alignItems="flex-end" gap={1}>
        <MDBox sx={{ minWidth: "14rem" }}>
          <MDSelect
            label="Carpetas"
            options={[
              { value: "", label: "Limpiar" },
              ...(carpetas?.map((el) => ({
                value: el.id,
                label: (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      "&:hover .action-icons": {
                        visibility: "visible",
                      },
                    }}
                  >
                    <span>{el.nombre}</span>
                    <Box
                      className="action-icons"
                      onClick={(e) => e.stopPropagation()}
                      sx={{
                        visibility: "hidden",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Tooltip title="Editar carpeta">
                        <Box
                          component="span"
                          onClick={(e) => {
                            handleEditCarpeta(el, e);
                          }}
                          sx={{
                            cursor: "pointer",
                            p: "4px",
                            ml: 1,
                            display: "inline-flex",
                            alignItems: "center",
                            lineHeight: 0,
                            "&:hover": {
                              opacity: 0.7,
                            },
                          }}
                        >
                          <Icon fontSize="small">edit</Icon>
                        </Box>
                      </Tooltip>
                      <Tooltip title="Eliminar carpeta">
                        <Box
                          component="span"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleToast({
                              title: "¿Estás seguro?",
                              text: `¡Si eliminas la carpeta: "${el.nombre}", la acción no se podrá revertir!`,
                              dispatcher: (result) => {
                                if (result.isConfirmed) {
                                  handleDeleteCarpeta(el.id, e);
                                }
                              },
                            });
                          }}
                          sx={{
                            cursor: "pointer",
                            p: "4px",
                            ml: 0.5, // Margen izquierdo más pequeño entre iconos
                            display: "inline-flex",
                            alignItems: "center",
                            lineHeight: 0,
                            "&:hover": {
                              opacity: 0.7,
                            },
                          }}
                        >
                          <Icon fontSize="small">delete</Icon>
                        </Box>
                      </Tooltip>
                    </Box>
                  </Box>
                ),
              })) || []),
            ]}
            value={carpeta}
            onChange={(val) =>
              handleChange({ target: { name: "carpetas", value: val } })
            }
          />
        </MDBox>
        <MDButton
          variant="gradient"
          color="info"
          size="medium"
          onClick={handleOpenCarpeta}
          circular
          iconOnly
        >
          <Tooltip placement="top" title={"Crear nueva carpeta"}>
            <Icon fontSize={"md"}>add</Icon>
          </Tooltip>
        </MDButton>
      </MDBox>
    </>
  );
};
